import { type ReactNode } from "react";
import { Link } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router";
import CDS from "design-system";
import { TaskSummary } from "features/Resources/Task/models";
import { useTaskStats } from "features/NewHireJourney/Components/Overview/hooks";
import HeaderStatCard from "./HeaderStatCard";

interface HeaderTaskProgressCardProps {
  newHireJourneyId: string;
  tasks: TaskSummary[] | undefined;
}

export default function HeaderTaskProgressCard({ newHireJourneyId, tasks }: HeaderTaskProgressCardProps) {
  const { openCount, overdueCount, completed, total } = useTaskStats(tasks);

  const doneFragment = `${completed} of ${total} complete`;
  const openFragment = openCount > 0 ? `${openCount} open` : null;

  let hero: ReactNode;
  let texture: string;

  if (overdueCount > 0) {
    hero = (
      <Link
        as={RouterLink}
        to={`/new-hires/${newHireJourneyId}/tasks?filter=overdue&sort=due_asc`}
        _hover={{ textDecoration: "none", opacity: 0.85 }}
      >
        <CDS.Text16 fontWeight="600" color="status.danger">
          {overdueCount} overdue
        </CDS.Text16>
      </Link>
    );
    texture = [openFragment, doneFragment].filter(Boolean).join(" · ");
  } else if (openCount > 0) {
    hero = (
      <CDS.Text16 fontWeight="600" color="content.primary">
        {openCount} open
      </CDS.Text16>
    );
    texture = doneFragment;
  } else {
    hero = (
      <CDS.Text16 fontWeight="600" color="content.primary">
        All clear
      </CDS.Text16>
    );
    texture = doneFragment;
  }

  return <HeaderStatCard eyebrow="Task progress" hero={hero} texture={texture} flex="1" minW="200px" />;
}
